import React, { useState } from "react";
import { Table, Badge, Tag, Button } from "antd";
import * as DateFormater from "../../../../utils/DateFormater";
import * as MoneyFormater from "../../../../utils/MoneyFormater";
import { ValorPago } from "../Contrato/ValorPago";
import { NotaFiscalParcela } from "../Contrato/NotaFiscal";
import { SelectSituacao } from "../Contrato/SituationSelect";
import { SelectOperador } from "../Contrato/SelectOperador";
import { ValueHistory } from "../Contrato/ValueHistory";
import { ParcelaDetalhes } from "../ParcelaDetalhes";
import "./styles.css";

const firstDefined = (...values) => {
  for (let i = 0; i < values.length; i += 1) {
    const value = values[i];
    if (value !== undefined && value !== null) {
      return value;
    }
  }
  return undefined;
};

const ParcelasTabelaSimplificada = ({ parcelas, operacaoId, onUpdate }) => {
  const [detalhesParcelaId, setDetalhesParcelaId] = useState(null);
  const [valorPagoModalVisible, setValorPagoModalVisible] = useState(false);
  const [valorPagoParcela, setValorPagoParcela] = useState(null);
  const [historicoModalVisible, setHistoricoModalVisible] = useState(false);
  const [historicoParcelaId, setHistoricoParcelaId] = useState(null);

  const handleEditarValorPago = (parcela) => {
    setValorPagoParcela(parcela);
    setValorPagoModalVisible(true);
  };

  const closeValorPagoModal = () => {
    setValorPagoModalVisible(false);
    setValorPagoParcela(null);
  };

  const handleHistorico = (parcelaId) => {
    setHistoricoParcelaId(parcelaId);
    setHistoricoModalVisible(true);
  };

  const closeHistoricoModal = () => {
    setHistoricoModalVisible(false);
    setHistoricoParcelaId(null);
  };

  const columns = [
    {
      title: "Nº",
      dataIndex: "num_parcela",
      key: "num_parcela",
      width: 60,
      render: (num, record) => (
        <div className="parcela__numero">
          <Badge
            status={record.is_deleted ? "error" : "success"}
            text={`${num}º`}
          />
        </div>
      ),
    },
    {
      title: "VENCIMENTO",
      dataIndex: "dt_vencimento",
      key: "vencimento",
      width: 140,
      render: (data, record) => (
        <div>
          <div>{data ? DateFormater.format(data) : "-"}</div>
          {record.dias_em_atraso > 0 && (
            <Tag color="red" size="small">
              {record.dias_em_atraso} dias
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "VALOR",
      dataIndex: "valor_parcela",
      key: "valor",
      width: 120,
      align: "right",
      render: (value) => (value ? `R$ ${MoneyFormater.format(value)}` : "-"),
    },
    {
      title: "VALOR ATUALIZADO",
      dataIndex: "valor_atualizado",
      key: "atualizado",
      width: 140,
      align: "right",
      render: (value, record) => (
        <div>
          <strong>R$ {MoneyFormater.format(value || 0)}</strong>
          <Button
            type="link"
            size="small"
            icon="history"
            onClick={() => handleHistorico(record.id)}
          />
        </div>
      ),
    },
    {
      title: "VALOR AT. CC",
      dataIndex: "valor_atualizado_cc",
      key: "atualizado_cc",
      width: 140,
      align: "right",
      render: (value) => (value ? `R$ ${MoneyFormater.format(value)}` : "-"),
    },
    {
      title: "VALOR MULTA",
      dataIndex: "valor_multa",
      key: "valor_multa",
      width: 140,
      align: "right",
      render: (value) => (value ? `R$ ${MoneyFormater.format(value)}` : "-"),
    },
    {
      title: "VALOR MORA",
      dataIndex: "valor_mora",
      key: "valor_mora",
      width: 140,
      align: "right",
      render: (value) => (value ? `R$ ${MoneyFormater.format(value)}` : "-"),
    },
    {
      title: "OUTROS ENCARGOS",
      key: "outros_encargos",
      width: 200,
      render: (_, record) => {
        const contratado = firstDefined(
          record.valor_outros_contratado,
          record.outros_encargos,
          record.valor_outros_cc,
          0
        );
        const atraso = firstDefined(
          record.valor_outros_atraso,
          record.outros_encargos_atraso,
          0
        );
        const cc = firstDefined(record.encargos_cc, record.valor_outros_cc, 0);

        const hasOnlyTotal =
          !record.valor_outros_contratado &&
          !record.valor_outros_atraso &&
          !record.encargos_cc &&
          record.outros_encargos;

        if (hasOnlyTotal) {
          return (
            <div>R$ {MoneyFormater.format(record.outros_encargos || 0)}</div>
          );
        }

        return (
          <div className="parcela__multi-value">
            <div>
              <strong>Contratado:</strong> R${" "}
              {MoneyFormater.format(contratado || 0)}
            </div>
            <div>
              <strong>Atraso:</strong> R$ {MoneyFormater.format(atraso || 0)}
            </div>
            <div>
              <strong>CC:</strong> R$ {MoneyFormater.format(cc || 0)}
            </div>
          </div>
        );
      },
    },
    {
      title: "JUROS / TARIFAS",
      key: "juros",
      width: 200,
      render: (_, record) => {
        const contratado = firstDefined(
          record.valor_juros_contratado,
          record.juros,
          record.valor_juros_cc
        );
        const atraso = firstDefined(
          record.valor_juros_atraso,
          record.juros_atraso
        );
        const cc = firstDefined(record.tarifas_cc, record.valor_juros_cc);

        const hasOnlyTotal =
          !record.valor_juros_contratado &&
          !record.valor_juros_atraso &&
          !record.tarifas_cc &&
          record.juros;

        if (hasOnlyTotal) {
          return <div>R$ {MoneyFormater.format(record.juros || 0)}</div>;
        }

        return (
          <div className="parcela__multi-value">
            <div>
              <strong>Contratado:</strong> R${" "}
              {MoneyFormater.format(contratado || 0)}
            </div>
            <div>
              <strong>Atraso:</strong> R$ {MoneyFormater.format(atraso || 0)}
            </div>
            <div>
              <strong>CC:</strong> R$ {MoneyFormater.format(cc || 0)}
            </div>
          </div>
        );
      },
    },
    {
      title: "VALOR PAGO",
      dataIndex: "valor_pago",
      key: "pago",
      width: 130,
      render: (value, record) => (
        <Button type="link" onClick={() => handleEditarValorPago(record)}>
          {value ? `R$ ${MoneyFormater.format(value)}` : "Adicionar"}
        </Button>
      ),
    },
    {
      title: "Nº NOTA FISCAL",
      dataIndex: "numero_nf",
      key: "nf",
      width: 200,
      render: (nf, record) => (
        <div className="parcela__nf">
          <NotaFiscalParcela
            idParcela={record.id}
            initialValue={nf}
            data={{
              valor_pago: record.valor_pago,
              status_conciliado: record.status_conciliado,
              status_pago: record.status_pago,
            }}
          />
        </div>
      ),
    },
    {
      title: "SITUAÇÃO",
      dataIndex: "situacao",
      key: "situacao",
      width: 160,
      render: (situacao, record) => (
        <SelectSituacao
          situacao={situacao}
          parcelaId={record.id}
          updateFunction={onUpdate}
        />
      ),
    },
    {
      title: "OPERADOR",
      dataIndex: "operador",
      key: "operador",
      width: 160,
      render: (operador, record) => (
        <SelectOperador
          idParcela={record.id}
          currentOperatorId={operador}
          updateFunction={onUpdate}
        />
      ),
    },
    {
      title: "DETALHES",
      key: "detalhes",
      width: 160,
      render: (_, record) => {
        const entrada =
          record.data_cadastro ||
          record.dt_entrada_txt ||
          record.dt_cadastro ||
          null;
        const remocao = record.dt_remocao_txt || record.dt_saida_txt || null;

        return (
          <div className="parcela__detalhes">
            <div>
              <strong style={{ color: "#52c41a" }}>Entrada:</strong>{" "}
              {entrada ? DateFormater.format(entrada) : "---"}
            </div>
            <div>
              <strong style={{ color: "#f5222d" }}>Saída:</strong>{" "}
              {remocao ? DateFormater.format(remocao) : "---"}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={parcelas}
        rowKey="id"
        size="small"
        scroll={{ x: 2300 }}
        pagination={false}
        className="parcelas-tabela-simplificada"
      />

      {valorPagoParcela && (
        <ValorPago
          visible={valorPagoModalVisible}
          idParcela={valorPagoParcela.id}
          initialValue={valorPagoParcela.valor_pago}
          data={{
            numero_nf: valorPagoParcela.numero_nf,
            status_conciliado: valorPagoParcela.status_conciliado,
          }}
          updateFunction={() => {
            closeValorPagoModal();
            onUpdate();
          }}
          onCancel={closeValorPagoModal}
        />
      )}

      <ValueHistory
        visible={historicoModalVisible}
        parcela_id={historicoParcelaId}
        onCancel={closeHistoricoModal}
      />

      <ParcelaDetalhes
        visible={!!detalhesParcelaId}
        parcelaId={detalhesParcelaId}
        onClose={() => setDetalhesParcelaId(null)}
      />
    </div>
  );
};

export default ParcelasTabelaSimplificada;



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/ParcelasTabelaSimplificada/index.jsx